export default "__VITE_ASSET__BVT8uuXO__"